import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { SegmentedTabs } from './SegmentedTabs';

const TABS = [
  { key: 'summary', label: 'Summary' },
  { key: 'calendar', label: 'Calendar' },
];

const meta = {
  title: 'Challenges/SegmentedTabs',
  component: SegmentedTabs,
  args: {
    tabs: TABS,
    active: 'summary',
    onChange: () => undefined,
  },
} satisfies Meta<typeof SegmentedTabs>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Summary: Story = {
  args: { active: 'summary' },
};

export const Calendar: Story = {
  args: { active: 'calendar' },
};

const InteractiveSegmentedTabs = (args: React.ComponentProps<typeof SegmentedTabs>) => {
  const [active, setActive] = useState(args.active);
  return (
    <View style={{ width: 340 }}>
      <SegmentedTabs {...args} active={active} onChange={setActive} />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveSegmentedTabs {...args} />,
};
